import { render, staticRenderFns } from "./NewMessageHint.vue?vue&type=template&id=eb53b6fc&scoped=true&"
import script from "./NewMessageHint.vue?vue&type=script&lang=js&"
export * from "./NewMessageHint.vue?vue&type=script&lang=js&"
import style0 from "./NewMessageHint.vue?vue&type=style&index=0&id=eb53b6fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb53b6fc",
  null
  
)

export default component.exports